document.addEventListener("DOMContentLoaded", function () {
  const sliderConfigs = {
    mobile: {
      selector: ".recipe-swiper-mobile",
      params: {
        effect: "cards",
        cardsEffect: {
          perSlideOffset: 11,
          perSlideRotate: 0,
          slideShadows: false,
        },
        breakpoints: {
          480: { destroy: true }, 
        },
      }
    },
    desktop: {
      selector: ".recipe-swiper-desktop",
      params: {
        slidesPerView: 1.2,
        spaceBetween: 16,
        loop: false,
        pagination: false,
        autoplay: false,
        mousewheel: {
          forceToAxis: true,
        },
        freeMode: true,
        breakpoints: {
          320: { slidesPerView: 1.2 },
          650: { slidesPerView: 1.5 },
          980: { slidesPerView: 2.5 },
          1400: { slidesPerView: 3 },
        }
      }
    }
  };

  window.addEventListener('load', function() {
    requestAnimationFrame(() => {
      initializeAllSliders();
    });
  });
  
  setTimeout(() => {
    initializeAllSliders();
  }, 500);

  function initializeAllSliders() {
    Object.values(sliderConfigs).forEach(config => {
      initializeSliderType(config);
    });
  }

  function initializeSliderType(config) {
    const sliders = document.querySelectorAll(config.selector);
    
    sliders.forEach((slider) => {

        const container = slider.closest('.swiper-container');
        const sliderId = container?.getAttribute('data-slider-id');
        
        if (sliderId) {
          const nextButton = container.querySelector(`[data-slider-target="${sliderId}"].recipe-swiper-button-next`);
          const prevButton = container.querySelector(`[data-slider-target="${sliderId}"].recipe-swiper-button-prev`);
          
          if (nextButton && prevButton) {
            nextButton.removeEventListener('click', nextButton._swiperClickHandler);
            prevButton.removeEventListener('click', prevButton._swiperClickHandler);
            
            const nextHandler = (e) => {
              e.preventDefault();
              if (slider.swiper) {
                slider.swiper.slideNext();
              }
            };
            
            const prevHandler = (e) => {
              e.preventDefault();
              if (slider.swiper) {
                slider.swiper.slidePrev();
              }
            };
            
            nextButton._swiperClickHandler = nextHandler;
            prevButton._swiperClickHandler = prevHandler;
            
            nextButton.addEventListener('click', nextHandler);
            prevButton.addEventListener('click', prevHandler);
          }
      }
      
      if (slider && !slider.swiper) {
        const swiperParams = { ...config.params };
        Object.assign(slider, swiperParams);
        slider.initialize();
      }
    });
  }
});
